;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"06bd478a71ccb6ed545852c48f2676f1050f6f41"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

import { SHARED_SENTRY_CONFIG } from './sentry.shared.config';

Sentry.init({
  ...SHARED_SENTRY_CONFIG,
});
